module.exports = __webpack_public_path__ + "img/icon_monitor.9674f434.png";